import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-employer-lists',
  templateUrl: './employer-lists.component.html',
  styleUrl: './employer-lists.component.css'
})
export class EmployerListsComponent implements OnInit {
  authToken = localStorage.getItem('auth');

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };

  businessID = this.route.snapshot.params.businessID;
  interests = [];
  opening;
  shared_view = false;
  company = JSON.parse(localStorage.getItem('company_' + this.businessID));
  contacted_by = [];
  employer_lists = [];
  rights = [
    {
      highlighted: "Kaikilla",
      normal: " organisaatiossasi on oikeus nähdä profiili",
      icon_src: "../../assets/icons/people.svg",
      selected: false,
      id: 'all_in_organization',
      can_be_seen_by_others_in_same_business: true,
    },
    {
      highlighted: "Vain",
      normal: " sinulla on oikeus",
      icon_src: "../../assets/icons/lock_icon.svg",
      selected: false,
      id: 'only_me',
      can_be_seen_by_others_in_same_business: false,
    }
  ]

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private http: HttpClient,
    private route: ActivatedRoute,
    private authService: AuthService) { }

  ngOnInit(): void {

        //get quwery params tabid
        this.route.queryParams.subscribe(params => {
          
          //if params are included
          if(params.type == 'shared'){
            var query = "?type=shared";
            this.shared_view = true;
            this.fetchEmployerLists(query);
          }
          else {
            console.log('no_items')
            this.shared_view = false;
            this.fetchEmployerLists("");
          }
        });
  }

  fetchEmployerLists(query) {
    this.http.get(environment.EMPLOYER_LISTS + query, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.employer_lists = res.message;
        }
        else {
          this.employer_lists = [];
          console.log('buu')
        }

      }, (err: any) => {

      }
    )
  }


  fetchPublicProfile(data){


    this.http.get(environment.VALIDATE_HEADHUNTING_PROFILE + '/' + data._id, this.httpOptions).subscribe(
      (res: any) => {
        if(res.status == 200 ) {

          var obj = {
            profile: res.message[0]
          }

          var languages_obj_array = obj.profile.languages;
          var display_lang_str = "";

          for (let i = 0; i < languages_obj_array.length; i++) {
            var lang = languages_obj_array[i];
            console.log(lang);
            display_lang_str += lang.name_fi + ', ';
          }

          //remove last comma
          display_lang_str = display_lang_str.slice(0, -2);
          obj.profile.display_lang = display_lang_str;
          console.log(obj);

          this.opening = obj;
          console.log(this.opening)

          console.log(res.message, this.opening.profile)
          document.getElementById('oc-profile').click();
          
        }
        else {
          console.log('buu')
          this.opening;
        }
        
      }, (err: any) => {

      }
    )
  }

  createANewList(){
    var selected_right = this.rights.filter(x => x.selected == true);
    var title = (<HTMLInputElement>document.getElementById('list-title')).value;
    var description = (<HTMLInputElement>document.getElementById('list-description')).value;

    var req = {
      title: title,
      description: description,
      right: selected_right[0].id,
      profiles: [],
      can_be_seen_by_others_in_same_business: selected_right[0].can_be_seen_by_others_in_same_business,
    }

    //Save list 

    this.http.post(environment.EMPLOYER_LISTS, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          console.log(res);
          document.getElementById('close_create_new_list').click();
          this.fetchEmployerLists("");
        }
        else {
          console.log('buu')
        }

      }, (err: any) => {

      }
    )
  }
  selectRight(right){
    for (let i = 0; i < this.rights.length; i++) {
      const elm = this.rights[i];
      elm.selected = false;
    }
    
    for (let i = 0; i < this.rights.length; i++) {
      var elm = this.rights[i];
      if(elm == right){
        elm.selected = true;
      }
      
    }

    console.log(this.rights)

  }

  routeShared(){
    console.log('/'+this.businessID + '/lists')
    this.router.navigate(['/'+this.businessID + '/lists'], { 
      queryParams: { type: 'shared' } });

    
  }
}
